import { Explorer } from '~/api/repository'

export const explorerApi = new Explorer({
  BASE: import.meta.env.VITE_APP_API,
  WITH_CREDENTIALS: false,
})